import { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './Passwort.css';
import exp8Logo from '../svg/WebClient-Express8-Logo-Text-Web.svg';
import aaxLogo from '../svg/WebClient-ArchivX-Logo-Text-Web.svg';

import Header from '../component/Header';
import Footer from '../component/Footer';

import { PasswortProps } from '../interfaces';
import BackendProvider, { useBackend } from '../context/BackendContext';

const alertMessages: Record<string, string> = {
  INVALID_PASSWORD: 'Das Passwort erfüllt noch nicht die genannten Vorgaben: Es muss vom vorherigen Passwort abweichen, mindestens 12 Zeichen lang sein und Groß- und Kleinbuchstaben enthalten.',
  DIFFERENT_PASSWORDS: 'Der Text ist nicht identisch mit dem neu eigegebenen Passwort.'
};

function Passwort() {
  const navigate = useNavigate();
  const backend = useBackend();
  const [user, setUser] = useState({ bn_id: '', bn_name: '', bn_vorname: '' });
  const [password, setPassword] = useState('');
  const [repeatedPassword, setRepeatedPassword] = useState('');
  const [passwordVisible, setPasswordVisible] = useState<boolean>(false);
  const [repeatedPasswordVisible, setRepeatedPasswordVisible] = useState<boolean>(false);
  const [samePasswords, setSamePasswords] = useState(true);

  const passwordRequirements = useRef('');
  /* 
  useEffect(() => {
    const url = '/webclient/php/get_user.php';
    fetch(url)
      .then((res) => {
        if (!res.ok) {
          throw new Error('Anfrage fehlgeschlagen');
        }
        return res.json();
      })
      .then((data) => {
        setUser(data);
      })
      .catch((err) => {
        console.log(err.message);
      });
  }, []);
  */

  function handleChangePassword(event:React.ChangeEvent<HTMLInputElement>) {
    setPassword(event.currentTarget.value);

    if (event.currentTarget.value === '') {
      passwordRequirements.current = '';
    } else if (validatePassword(event.currentTarget.value)) {
      passwordRequirements.current = 'password-right';
    } else {
      passwordRequirements.current = 'password-wrong';
    }
  }

  const changeViewCallback = useCallback((newView:string) => {
    // changeView(newView);
  }, []);

  function validatePassword(input: string): boolean {
    if (input.length < 12) {
      return false;
    }
    const hasLowercase = /\p{Ll}/u.test(input);
    const hasUppercase = /\p{Lu}/u.test(input);
    const hasSpecial = /[^\p{L}\p{N}\s]/u.test(input);
    
    return hasLowercase && hasUppercase && hasSpecial;
  }

  function handleSubmit(event:React.FormEvent<HTMLFormElement>) {
    if (password !== '') {
      event.preventDefault();
      if (password !== repeatedPassword) {
        setSamePasswords(false);
      } else {
        const url = '/webclient/php/update_password.php';
        const form = new FormData(document.getElementById('password-change') as HTMLFormElement ?? undefined);

        fetch(url, { method: 'POST', body: form })
          .then((res) => {
            if (!res.ok) {
              throw new Error('Anfrage fehlgeschlagen');
            }
          })
          .then((data) => {
            navigate('/bestandsregie');
          })
          .catch((err) => {
            console.log(err.message);
          });
      }
    }
  }

  return (
    <div className="password-container">
      {/* <BackendProvider><Header /></BackendProvider> */}
      <Header />
      <main className="password-main">
        <div className="password-logo">
          <img aria-hidden="true" className="" src={backend === '1' ? aaxLogo : backend === '2' ? exp8Logo : ''} alt="" />
        </div>
        {/* <h1>Passwort ändern für { user.bn_vorname + ', ' + user.bn_name }</h1> */}
        <h1>Passwort ändern</h1>
        <h2>Das neue Passwort muss</h2>
        <ul>
          <li>vom vorherigen Passwort abweichen</li>
          <li>mindestens 12 Zeichen lang sein</li>
          <li>Groß- und Kleinbuchstaben enthalten</li>
          <li>mindestens ein Sonderzeichen enthalten</li>
        </ul>
        <form aria-label="Passwort ändern" id="password-change" onSubmit={handleSubmit}>  
          <div className="password-input">
            <label htmlFor="password">Neues Passwort</label>
            <div className="password-input-wrap">
              <input 
                type={passwordVisible ? 'text' : 'password'} 
                className={passwordRequirements.current} 
                name="password" 
                value={password} 
                onChange={handleChangePassword} 
              />
              <button type="button" className={passwordVisible ? 'eye-off' : 'eye'} onClick={() => setPasswordVisible(!passwordVisible)}>
                { /* <img src={passwordVisible ? eyeOff : eye} alt="" /> */ }
              </button>
            </div>
            { passwordRequirements.current === 'password-wrong' ? <div className="password-wrong-message">{alertMessages.INVALID_PASSWORD}</div> : null}
          </div>
          <div className="password-repeat">
            <label 
              htmlFor="password2"
              className={passwordRequirements.current === 'password-right' ? 'label-active' : ''}
            >
              Neues Passwort wiederholen
            </label>
            <div className="password-repeat-wrap">
              <input 
                type={repeatedPasswordVisible ? 'text' : 'password'} 
                className={
                  passwordRequirements.current === 'password-right' && repeatedPassword === password 
                    ? 
                    'password-active password-right' 
                    : 
                    ''
                } 
                value={repeatedPassword} 
                onChange={(e) => setRepeatedPassword(e.target.value)} 
                disabled={passwordRequirements.current !== 'password-right'}
                aria-disabled={passwordRequirements.current !== 'password-right'}
              />
              <button type="button" className={repeatedPasswordVisible ? 'eye-off' : 'eye'} onClick={() => setRepeatedPasswordVisible(!repeatedPasswordVisible)}>
                { /* <img src={repeatedPasswordVisible ? eyeOff : eye} alt="" /> */ }
              </button>
            </div>
            { !samePasswords ? <div className="password-wrong-message">{alertMessages.DIFFERENT_PASSWORDS}</div> : null}
          </div>
          <div className="password-buttons">
            <button type="submit">Speichern und zurück zur Bestandsregie</button>
            <button type="button" onClick={() => navigate('/bestandsregie')}>Abbrechen und zurück zur Bestandsregie</button>
          </div>             
        </form>
      </main>
      <Footer />
    </div>
  );
}

export default Passwort;
